import { render, staticRenderFns } from "./ApplicationDetail.vue?vue&type=template&id=4e54e1c0&scoped=true&"
import script from "./ApplicationDetail.vue?vue&type=script&lang=ts&"
export * from "./ApplicationDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ApplicationDetail.vue?vue&type=style&index=0&id=4e54e1c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e54e1c0",
  null
  
)

export default component.exports